import { render, staticRenderFns } from "./TabHierarchicalMedical.vue?vue&type=template&id=6ef6caea&scoped=true"
import script from "./TabHierarchicalMedical.vue?vue&type=script&lang=js"
export * from "./TabHierarchicalMedical.vue?vue&type=script&lang=js"
import style0 from "./TabHierarchicalMedical.vue?vue&type=style&index=0&id=6ef6caea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef6caea",
  null
  
)

export default component.exports